import { render, staticRenderFns } from "./PresOptionsTab.vue?vue&type=template&id=197536c7&scoped=true"
import script from "./PresOptionsTab.vue?vue&type=script&lang=js"
export * from "./PresOptionsTab.vue?vue&type=script&lang=js"
import style0 from "./PresOptionsTab.vue?vue&type=style&index=0&id=197536c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197536c7",
  null
  
)

export default component.exports